import { render, staticRenderFns } from "./VehicleCancelPolicy.vue?vue&type=template&id=20cac4e5&scoped=true&"
import script from "./VehicleCancelPolicy.vue?vue&type=script&lang=js&"
export * from "./VehicleCancelPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cac4e5",
  null
  
)

export default component.exports